import { Context } from "@nuxt/types/app";

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export default function (context: Context) {
  function isNumberOnlyEvent(event: Event, value: string): boolean {
    if (/^[0-9]*$/.test(value)) {
      return true;
    }

    event.preventDefault();
    return false;
  }

  return {
    isNumberOnlyEvent,
  };
}
